import Box from "@mui/material/Box";
import {
  BUTTON_FINISH,
  BUTTON_NEXT,
  BUTTON_PREVIOUS,
  BUTTON_SKIP,
} from "../../i18n/keysTranslations";
import PreviousButtonStep from "../Buttons/PreviousButtonStep";
import NextButtonStep from "../Buttons/NextButtonStep";
import { useTranslationApp } from "../../lib/i18next";
import { ADS_CAMPAIGN_STATUS_DEACTIVATED } from "../../utils/constants";
import Loader from "../Loaders/Loader";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import Button from "../Buttons/Button";

const ActionsButtons = ({
  onPreviousStep,
  onNextStep,
  onFinish,
  customComponentPreviousSave,
  customComponentPreviousNext,
  customComponentBelow,
  showSaveButton = false,
  saveButtonText = BUTTON_FINISH,
  hasAdvancedSettings = false,
  showNextButton = true,
  showPreviousButton = true,
  showSkipButton = false,
  onSkipStep,
  disabledNextButton = false,
  disabledPreviousButton = false,
  disabledSaveButton = false,
  colorNextButton = "primary",
  loading,
  showLoadingComponent = false,
  customComponentLoading,
}) => {
  const [isLoadingNextStep, setIsLoadingNextStep] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const { t } = useTranslationApp();

  if (showLoadingComponent && loading) {
    if (customComponentLoading) {
      return customComponentLoading;
    }
    return <Loader size={40} fullWidth />;
  }

  const hasMoreThreeButtons =
    showNextButton &&
    showPreviousButton &&
    (showSaveButton ||
      hasAdvancedSettings ||
      customComponentPreviousNext ||
      customComponentPreviousSave);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        mt: 3,
        mb: 2,
        gap: customComponentBelow ? 1.5 : 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: hasMoreThreeButtons ? "column" : "row",
            sm: "row",
          },
          gap: { xs: 1, sm: 2 },
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        {showPreviousButton && (
          <PreviousButtonStep
            disabled={disabledPreviousButton}
            fullWidth={isMobile}
            sx={{
              minWidth: 120,
              borderRadius: 2,
            }}
            onPreviousStep={onPreviousStep}
          >
            {t(BUTTON_PREVIOUS)}
          </PreviousButtonStep>
        )}
        {customComponentPreviousNext && customComponentPreviousNext}
        {showSkipButton && (
          <Button
            fullWidth={isMobile}
            sx={{
              minWidth: 120,
              borderRadius: 2,
            }}
            variant="contained"
            color="secondary"
            type="button"
            onClick={onSkipStep}
          >
            {t(BUTTON_SKIP)}
          </Button>
        )}
        {showNextButton && (
          <NextButtonStep
            disabled={disabledNextButton}
            loading={isLoadingNextStep}
            fullWidth={isMobile}
            sx={{ minWidth: 120, borderRadius: 2 }}
            color={colorNextButton}
            onNextStep={async () => {
              setIsLoadingNextStep(true);
              await onNextStep();
              setIsLoadingNextStep(false);
            }}
          >
            {t(BUTTON_NEXT)}
          </NextButtonStep>
        )}
        {customComponentPreviousSave && customComponentPreviousSave}
        {showSaveButton && (
          <Button
            disabled={disabledSaveButton}
            fullWidth={isMobile}
            loading={loading}
            onClick={() => onFinish(ADS_CAMPAIGN_STATUS_DEACTIVATED)}
            sx={{
              minWidth: 120,
              borderRadius: 2,
            }}
            variant="contained"
            color="primary"
            type="button"
          >
            {t(saveButtonText)}
          </Button>
        )}
      </Box>
      {customComponentBelow}
    </Box>
  );
};

export default ActionsButtons;
